@use '@/scss/underscore' as _;

.container {
  position: relative;

  > div:not(:last-child) {
    margin-bottom: _.unit(4);
  }
}
